import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import BoxSections from './BoxSections'
import ContentDiv from './ContentDiv'
import HeroSections from './HeroSections'
import KeyFeature from './KeyFeature'
import { Helmet } from 'react-helmet'

export default function Main_nft(props) {
    const { nft_slug } = useParams()
    // =========================== scroll To Top default =========================
    useEffect(() => {
        props.demo('top')
    }, [nft_slug])
    // =========================== scroll To Top default =========================
    return (
        <>
           <Helmet>
                <title>Wireframing & Prototyping Services – Infograins</title>
                <meta name="description" content="Infograins provides a comprehensive range of wireframe design solutions and interactive prototyping services to assist organizations in crafting mockups for web, mobile applications, user experience (UX), user interface (UI), digital interfaces, and beyond." />
            </Helmet>
            <HeroSections />
            <BoxSections />
            <ContentDiv />
            <KeyFeature />
        </>
    )
}
